<template>
  <div class="reassign-selection-column">
    <div v-if="title || helperText" class="reassign-selection-header">
      <h4>{{ title }}</h4>
      <p v-if="helperText" class="helper">{{ helperText }}</p>
    </div>

    <b-field v-if="showFilter" class="reassign-filter-field">
      <b-input
        :value="filterValue"
        :placeholder="filterPlaceholder"
        type="search"
        icon="magnify"
        @input="onFilterInput"
      ></b-input>
    </b-field>

    <div v-if="items.length === 0" class="empty-state">
      {{ emptyStateText }}
    </div>

    <div v-else class="reassign-table-wrapper">
      <table class="reassign-items-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <b-checkbox
                v-if="showSelectAll"
                :value="selectAllValue"
                @input="onSelectAll($event)"
              ></b-checkbox>
            </th>
            <th>Title</th>
            <th>Site</th>
            <th v-if="showDocumentNumber">Document #</th>
            <th v-if="showProjectInfoText">Project Info</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item._id">
            <td class="checkbox-col">
              <b-checkbox
                :value="selectedIds.includes(item._id)"
                @input="onToggle(item._id, $event)"
              ></b-checkbox>
            </td>
            <td>
              <span class="cell-text" :title="item.title || ''">
                {{ item.title || '—' }}
              </span>
            </td>
            <td>
              <span class="cell-text" :title="item.siteName || ''">
                {{ item.siteName || '—' }}
              </span>
            </td>
            <td v-if="showDocumentNumber">
              <span class="cell-text" :title="item.documentNumber || ''">
                {{ item.documentNumber || '—' }}
              </span>
            </td>
            <td v-if="showProjectInfoText">
              <span class="cell-text" :title="item.projectInfoText || ''">
                {{ item.projectInfoText || '—' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReassignItemsPanel',
  props: {
    title: {
      type: String,
      default: '',
    },
    helperText: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    emptyStateText: {
      type: String,
      default: 'No items available.',
    },
    showFilter: {
      type: Boolean,
      default: false,
    },
    filterValue: {
      type: String,
      default: '',
    },
    filterPlaceholder: {
      type: String,
      default: 'Filter items...',
    },
    showDocumentNumber: {
      type: Boolean,
      default: false,
    },
    showProjectInfoText: {
      type: Boolean,
      default: false,
    },
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    selectAllValue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onToggle(id, selected) {
      this.$emit('toggle', { id, selected });
    },
    onFilterInput(value) {
      this.$emit('filterInput', value);
    },
    onSelectAll(selected) {
      this.$emit('selectAll', selected);
    },
  },
};
</script>

<style scoped lang="scss">
.reassign-selection-header {
  margin-bottom: 8px;
}

.reassign-filter-field {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: inherit;
  padding-top: 2px;
  margin-bottom: 10px;
}

.reassign-table-wrapper {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.reassign-items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
}

.reassign-items-table thead th {
  position: sticky;
  top: 0;
  background: #f8f9fb;
  text-align: left;
  font-weight: 600;
  color: #4a4a4a;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 10px;
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reassign-items-table tbody td {
  border-bottom: 1px solid #f0f1f3;
  padding: 8px 10px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reassign-items-table tbody tr:hover {
  background: #fafbff;
}

.checkbox-col {
  width: 42px;
}

.cell-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
